module.exports = __webpack_public_path__ + "static/media/news.69172e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/news.png
// module id = 1230
// module chunks = 0